'use client';

var __jsx = React.createElement;
import React, { useState } from 'react';
import useAfterInitEffect from '@lib/hooks/use-after-initialization-effect';
import { IMaskInput } from 'react-imask';
import { useTranslations } from 'next-intl';
import { cn } from '@lib/cn';
import { ALPHA_NUMERIC_REGEX, ALPHABETIC_REGEX, NUMERIC_REGEX } from '@lib/constants';
import useCssModules from '@lib/hooks/use-css-modules';
const MuscleFormTextInput = _ref => {
  let {
    value,
    placeholder,
    placeholderClassName,
    onChangeValue = () => {},
    label = '',
    fullLength = false,
    disabled = false,
    mask,
    description,
    rightDecoration,
    leftDecoration,
    valueIsInvalid = false,
    secureTextEntry = false,
    invalidValueMessage,
    required = false,
    name = '',
    inputClassName = '',
    labelClassName = '',
    borderClassName = '',
    mode = 'freetext',
    maxLength,
    descriptionClassName,
    inputContainerClassName,
    reserveErrorSpace = false,
    hideEmptyLabel = false,
    dataTestId
  } = _ref;
  const t = useTranslations('Shared.TextInput');
  const {
    cssModules
  } = useCssModules();
  const {
    inputContainerClassName: globalInputContainerClassName,
    inputLabelClassName: globalInputLabelClassName
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.formBuilder) || {};
  const {
    0: textInput,
    1: setTextInput
  } = useState(value);
  useAfterInitEffect(() => {
    setTextInput(value);
  }, [value]);
  const handleChange = event => {
    if (canTypeCharacter(event.target.value, event.nativeEvent.data)) {
      setTextInput(event.target.value);
      onChangeValue(event.target.value);
    }
  };
  const handleAccept = value => {
    setTextInput(value);
    onChangeValue(value);
  };
  const canTypeCharacter = (value, character) => {
    var _textInput$length;
    if (maxLength && value.length > maxLength) {
      return false;
    }

    // If the value is being deleted or passes the content test, allow it
    return getValueTesterBasedOnMode().test(character) || value.length < ((_textInput$length = textInput === null || textInput === void 0 ? void 0 : textInput.length) !== null && _textInput$length !== void 0 ? _textInput$length : 0);
  };
  const getValueTesterBasedOnMode = () => {
    if (mode === 'alphabetic') {
      return ALPHABETIC_REGEX;
    } else if (mode === 'alphanumeric') {
      return ALPHA_NUMERIC_REGEX;
    } else if (mode === 'numeric') {
      return NUMERIC_REGEX;
    }
    return {
      test: () => true
    };
  };
  return __jsx("div", {
    className: "".concat(inputClassName, " w-full")
  }, (!hideEmptyLabel || hideEmptyLabel && label) && __jsx("label", {
    className: cn(globalInputLabelClassName, labelClassName),
    form: name
  }, label ? "".concat(label, " ").concat(required ? '*' : '') : '\u00A0'), __jsx("div", {
    className: cn(globalInputContainerClassName, inputContainerClassName, borderClassName, {
      'error': valueIsInvalid
    })
  }, leftDecoration, mask ? __jsx(IMaskInput, {
    "data-testid": dataTestId,
    className: cn('outline-none focus:outline-none focus-visible:outline-none w-full bg-transparent', inputContainerClassName, placeholderClassName),
    mask: mask,
    unmask: false,
    onAccept: handleAccept,
    placeholder: placeholder,
    value: textInput || '',
    disabled: disabled
  }) : __jsx("input", {
    "data-testid": dataTestId,
    disabled: disabled,
    className: cn('outline-none focus:outline-none focus-visible:outline-none w-full bg-transparent', inputContainerClassName),
    value: textInput,
    onChange: handleChange,
    placeholder: placeholder,
    type: secureTextEntry ? 'password' : 'text',
    name: name
  }), rightDecoration), description ? __jsx(React.Fragment, null, __jsx("div", {
    className: cn(' text-primary_text mt-1 tx-pxs-light', descriptionClassName)
  }, description)) : null, reserveErrorSpace && __jsx("div", {
    className: "text-error-main mt-1 text-start tx-pxs-light"
  }, valueIsInvalid && invalidValueMessage ? invalidValueMessage : '\u00A0'), !reserveErrorSpace && valueIsInvalid && invalidValueMessage && __jsx("div", {
    className: "text-error-main mt-1 text-start tx-pxs-light max-w-[300px] md:max-w-[500px]"
  }, invalidValueMessage));
};
export default MuscleFormTextInput;